f<template>
  <div id="bd-dashboard">
    <el-container>
      <el-aside width="65px" style="height: 100%;">
        <bd-side></bd-side>
      </el-aside>
      <el-container>
        <el-main>
          <transition
            mode="out-in"
            enter-active-class="fadeIn"
            leave-active-class="fadeOut"
            appear
          >
            <router-view class="animated"></router-view>
          </transition>
        </el-main>
        <el-footer height="20px">
          <!-- TODO:统计信息, 手动 && 间隔自动刷新 -->
          <!-- 提醒客服扫码绑定微信，TODO: 推送日报、周报、月报等数据 -->
          <!-- TODO: 平均人工响应时长(秒) = 8:00-23:00期间，买家每次发消息，到商家客服人工回复，买家所等待的平均时长。对比：较前一日，默认一个月变化曲线 -->
          <!-- TODO: 30秒应答率 = 8:00-23:00期间，买家所发的消息，商家客服在30秒内人工回复了的百分比。对比：较前一日，默认一个月变化曲线 -->
          <!-- TODO: 3分钟人工回复率 =（咨询人数 - 3分钟未人工回复累计）/咨询人数。注意：1、仅计8：00-23：00的咨询 2、用户有任一条消息超过3分钟未人工回复，则该用户计入3分钟未人工回复累计 -->
          <!-- TODO: 满意度评分≤3会话数 = 当日评分的会话，客户咨询过客服且≤3分的会话数/总评价会话数 -->
          <span v-if="showBottomStatistics">
            <el-tooltip :content="refreshTodayStatisticTip" placement="top">
              <i
                @click="refreshStatisticData"
                class="el-icon-refresh statistic-data"
                style="margin-top:3px;"
                size="mini"
              >
                {{ today }}{{ $t("dayData") }}:</i
              >
            </el-tooltip>
            <!-- <el-tooltip content="今日首次上线时间" placement="top">
              <i class="statistic-data" size="mini" v-if="showAuthority.debug">TODO:首次上线时间</i>
            </el-tooltip> -->
            <!-- <el-tooltip content="今日在线时长" placement="top">
              <i class="statistic-data" size="mini" v-if="showAuthority.debug">TODO:在线时长</i>
            </el-tooltip> -->
            <!-- <el-tooltip content="今日接待时长" placement="top">
              <i class="statistic-data" size="mini" v-if="showAuthority.debug">TODO:接待时长</i>
            </el-tooltip> -->
            <el-tooltip :content="todayThreadCountTip" placement="top">
              <i class="statistic-data" size="mini"
                >{{ $t("threadCount") }}:
                {{ statisticsAgentToday.threadCount }},</i
              >
            </el-tooltip>
            <el-tooltip
              :content="responseRateToVisitorMessageIn30SecondsTip"
              placement="top"
            >
              <i class="statistic-data" size="mini"
                >{{ $t("responseRateIn30Seconds") }}:
                {{
                  Math.round(statisticsAgentToday.lt30sRate * 100) / 100
                }}%,</i
              >
            </el-tooltip>
            <el-tooltip
              :content="responseRateIn3mComputeMethodTip"
              placement="top"
            >
              <i class="statistic-data" size="mini"
                >{{ $t("responseRateIn3Minutes") }}:
                {{
                  Math.round(statisticsAgentToday.responseLt3mRate * 100) / 100
                }}%,</i
              >
            </el-tooltip>
            <el-tooltip :content="satisfyRateComputeMethodTip" placement="top">
              <i class="statistic-data" size="mini"
                >{{ $t("satisfyRate") }}:
                {{
                  Math.round(statisticsAgentToday.satisfyRate * 100) / 100
                }}%,</i
              >
            </el-tooltip>
            <!-- <el-tooltip content="首次人工响应平均时长" placement="top">
              <i class="statistic-data" size="mini" v-if="showAuthority.debug">TODO: 首次人工响应平均时长: 秒,</i>
            </el-tooltip> -->
            <el-tooltip
              :content="agentAverageResponseTimeNoteTip"
              placement="top"
            >
              <i class="statistic-data" size="mini"
                >{{ $t("agentAverageResponseTime") }}:
                {{
                  Math.round(statisticsAgentToday.averageResponseLength * 100) /
                    100
                }}{{ $t("second") }},</i
              >
            </el-tooltip>
            <el-tooltip :content="todaySendMessageCountTip" placement="top">
              <i class="statistic-data" size="mini"
                >{{ $t("sendMessageCount") }}:
                {{ statisticsAgentToday.agentMessageCount }},</i
              >
            </el-tooltip>
            <el-tooltip :content="todaySendMessageWordCountTip" placement="top">
              <i class="statistic-data" size="mini"
                >{{ $t("sendMessageWordCount") }}:
                {{ statisticsAgentToday.agentWordCount }},</i
              >
            </el-tooltip>
            <el-tooltip :content="todayReceiveMessageCountTip" placement="top">
              <i class="statistic-data" size="mini"
                >{{ $t("receiveMessageCount") }}:
                {{ statisticsAgentToday.visitorMessageCount }},</i
              >
            </el-tooltip>
            <el-tooltip
              :content="todayReceiveMessageWordCountTip"
              placement="top"
            >
              <i class="statistic-data" size="mini"
                >{{ $t("receiveMessageWordCount") }}:
                {{ statisticsAgentToday.visitorWordCount }}</i
              >
            </el-tooltip>
          </span>
          <!-- TODO: 对接良师宝之后，增加指标：询单人数、成团人数、询单转化率、客服销售额 -->
          <span v-if="showBottomRightButtons">
            <el-popover
              placement="top"
              width="260"
              style="cursor:pointer; float: right;"
              v-model="ratePopoverVisible"
            >
              <h4>{{ $t("sendUsFeedback") }}：</h4>
              <p>{{ $t("howDoYouFeel") }}</p>
              <el-rate v-model="rateValue" show-text></el-rate>
              <p>{{ $t("tellUsReason") }}</p>
              <el-input
                type="textarea"
                :rows="3"
                :placeholder="inputFeedbackTip"
                v-model="rateContent"
              >
              </el-input>
              <div style="text-align: right; margin-top: 10px;">
                <el-button
                  size="mini"
                  type="text"
                  @click="ratePopoverVisible = false"
                  >{{ $t("cancel") }}</el-button
                >
                <el-button type="primary" size="mini" @click="submitRate">{{
                  $t("ok")
                }}</el-button>
              </div>
              <i slot="reference" class="el-icon-star-off" size="mini"></i>
            </el-popover>
            <el-tooltip :content="downloadTip" placement="top">
              <i
                @click="onDownload"
                class="el-icon-download help-chat"
                size="mini"
              ></i>
            </el-tooltip>
            <el-tooltip :content="onlineChatTip" placement="top">
              <i
                @click="onChat"
                class="el-icon-headset help-chat"
                size="mini"
              ></i>
            </el-tooltip>
            <el-tooltip :content="helpcenterTip" placement="top">
              <i @click="onHelp" class="el-icon-help help-chat" size="mini"></i>
            </el-tooltip>
            <el-tooltip :content="mpTip" placement="top">
              <i
                @click="queryOpenId"
                class="el-icon-mobile-phone help-chat"
                size="mini"
              ></i>
            </el-tooltip>
            <el-tooltip :content="rechargeTip" placement="top">
              <i
                @click="onRenew"
                class="help-chat"
                style="font-size: 10px; color: #ff0000"
                size="mini"
                >{{ valideDate }}</i
              >
            </el-tooltip>
            <el-tooltip content="version" placement="top">
              <span style="font-size: 10px; margin-top: 2px; float: right;">{{ version }}</span>
            </el-tooltip>
          </span>
          <!-- <span v-else style="font-size: 10px;">{{ defaultTitle }}</span> -->
        </el-footer>
      </el-container>
    </el-container>
    <audio id="audioPlay" :src="soundUrl" hidden="true" />
    <!-- 创建工单 -->
    <el-drawer
      :title="createTicketTip"
      :visible.sync="ticketDrawerVisible"
      :direction="drawerDirection"
      :before-close="handleDrawerClose"
      size="50%"
    >
      <div class="demo-drawer__content">
        <el-form :model="ticket">
          <el-form-item
            :label="ticketCategoryTip"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="ticket.cid"
              :placeholder="chooseTip"
              size="mini"
            >
              <el-option
                v-for="item in categoryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <p v-if="categoryOptions.length === 0">
              {{ $t("ticketCategoryTip") }}
            </p>
          </el-form-item>
          <el-form-item :label="titleTTip" :label-width="formLabelWidth">
            <el-input
              :placeholder="titleTTip"
              v-model="ticket.title"
              autocomplete="off"
              style="width: 80%;"
              size="mini"
            clearable></el-input>
          </el-form-item>
          <el-form-item :label="contentTip" :label-width="formLabelWidth">
            <!-- <el-input
              type="textarea"
              :rows="2"
              :placeholder="contentTip"
              v-model="ticket.content"
              style="width: 80%;"
            ></el-input> -->
            <tinymce v-model="ticket.content"></tinymce>
            <!-- https://blog.csdn.net/liujun03/article/details/84453287 -->
            <!-- <vue-ueditor-wrap v-model="ticket.content" :config="ueditorConfig" style="width: 90%;"></vue-ueditor-wrap> -->
          </el-form-item>
          <el-form-item :label="attachementsTip" :label-width="formLabelWidth">
            <el-upload
              class="bd-upload-file"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="6"
              :on-exceed="handleExceed"
              :file-list="uploadedFileList"
              :data="upload_data"
              :name="upload_name"
              :action="uploadFileServerUrl"
              :on-success="handleFileUploadSuccess"
              :before-upload="beforeFileUpload"
            >
              <el-button size="mini" type="primary">{{
                $t("upload")
              }}</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ $t("noExceed6file") }}
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="priorityTip" :label-width="formLabelWidth">
            <el-radio-group v-model="ticket.urgent">
              <el-radio :label="false">{{ $t("normal") }}</el-radio>
              <el-radio :label="true">{{ $t("urgent") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="状态" :label-width="formLabelWidth">
            <el-radio-group v-model="ticket.status">
              <el-radio label="waiting">尚未受理</el-radio>
              <el-radio label="processing">受理中</el-radio>
              <el-radio label="to_be_replied">等待回复</el-radio>
              <el-radio label="done">已解决</el-radio>
              <el-radio label="closed">已关闭</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item :label="agentTypeTip" :label-width="formLabelWidth">
            <el-radio-group v-model="ticket.handlerType">
              <!-- 技能组 -->
              <el-radio label="workgroup" v-if="!isProduction">{{ $t('workGroup') }}</el-radio>
              <!-- 指定客服 -->
              <el-radio label="appointed">{{ $t("appointed") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="showBindCurrentThread"
            :label="bindCurrentThreadTip"
            :label-width="formLabelWidth"
          >
            <el-checkbox v-model="bindCurrentThread">{{
              userCurrentThread.nickname
            }}</el-checkbox>
          </el-form-item>
          <el-form-item
            v-if="ticket.handlerType === 'workgroup'"
            :label="workGroupTip"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="ticket.wid"
              :placeholder="chooseTip"
              size="mini"
            >
              <el-option
                v-for="item in workgroupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="ticket.handlerType === 'appointed'"
            :label="appointedTip"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="ticket.uid"
              :placeholder="chooseTip"
              size="mini"
            >
              <el-option
                v-for="item in agentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="ticketDrawerVisible = false" size="mini">{{
            $t("cancel")
          }}</el-button>
          <el-button type="primary" @click="createTicket" size="mini" :disabled="categoryOptions.length === 0">{{
            $t("ok")
          }}</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 绑定微信公众号 -->
    <el-dialog
      v-dialogDrag
      title="微信扫一扫，接收账户变动通知"
      :visible.sync="centerMpDialogVisible"
      width="30%"
      center
    >
      <div id="mp_qrcode"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerMpDialogVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button type="primary" @click="centerMpDialogVisible = false">{{
          $t("ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
// import VueUeditorWrap from 'vue-ueditor-wrap'
import BdSide from "@/components/dashboard/aside/BdSide";
import * as https from "@/apis/http";
import bus from "@/util/eventbus";
import moment from "moment";
// import md5 from "md5"
const constants = require("@/util/constants");
// var registerServiceWorker = require('serviceworker!./sw.js');

export default {
  name: "bd-dashboard",
  components: { BdSide }, // VueUeditorWrap
  data() {
    return {
      isProduction: constants.IS_PRODUCTION,
      version: process.env.VUE_APP_VERSION,
      bindCurrentThread: true,
      drawerDirection: "rtl",
      ticketDrawerVisible: false,
      centerMpDialogVisible: false,
      //
      hidden: true,
      browserTitle: "",
      shouldScrollBrowserTitle: false,
      soundUrl: constants.SOUND_DINGDONG_URL,
      //
      iconUrl: constants.ICON_URL,
      homeUrl: constants.HOME_URL,
      downloadUrl: constants.DOWNLOAD_URL,
      rechargeUrl: constants.RECHARGE_URL,
      rechargeHelpUrl: constants.RECHARGE_HELP_URL,
      chatUrl: constants.CHAT_URL,
      helpUrl: constants.HELP_URL,
      renewUrl: constants.RENEW_URL,
      electron: constants.IS_ELECTRON,
      //
      rateValue: 3,
      rateContent: "",
      ratePopoverVisible: false,
      //
      isCreateTicket: true,
      ticket: {
        // id: 0,
        tid: "",
        title: "",
        content: "",
        cid: "",
        attachments: [],
        urgent: false,
        status: "waiting",
        handlerType: "appointed",
        wid: "",
        uid: "",
        ttid: "",
        client: constants.HTTP_CLIENT,
      },
      categoryOptions: [],
      workgroupOptions: [],
      agentOptions: [],
      // 上传图片相关参数
      upload_headers: {
        "X-CSRF-TOKEN": "",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
        Authorization: "Bearer ",
      },
      upload_data: {
        file_name: "test.png",
        username: "",
        type: "",
        client: "web"
      },
      upload_name: "file",
      // 接收图片服务器地址
      uploadFileServerUrl: constants.UPLOAD_FILE_URL_V3, // constants.UPLOAD_FILE_URL,
      // 上传图片结果集, 格式：{name: '', url: ''}
      uploadedFileList: [],
      uploadFileType: "",
      //
      formLabelWidth: "110px",
      // onLine: navigator.onLine,
      ///
      refreshDate: false,
      shouldQueryMpQrcodeUrl: true,
      // timer: 0,
      applicationServerPublicKey:
        "BL-QDiXy6tVqbXClGLN8mBoQSOYTV6KOhX90GFEISJCKXSEa7si2zK1dUgWZDsAJENIZD1Jqa__WiSCCN1PTTcA=",
    };
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "userContacts",
      "userCurrentThread",
      "showAuthority",
      "statisticsAgentToday",
      "showBottomStatistics",
      "userNodisturbThreadTopics",
      "isWebrtcStarted",
    ]),
    createTicketTip() {
      return this.$t("createTicket");
    },
    ticketCategoryTip() {
      return this.$t("ticketCategory");
    },
    chooseTip() {
      return this.$t("choose");
    },
    titleTTip() {
      return this.$t("title");
    },
    contentTip() {
      return this.$t("content");
    },
    attachementsTip() {
      return this.$t("attachements");
    },
    agentTypeTip() {
      return this.$t("agentType");
    },
    bindCurrentThreadTip() {
      return this.$t("bindCurrentThread");
    },
    workGroupTip() {
      return this.$t("workGroup");
    },
    appointedTip() {
      return this.$t("appointed");
    },
    priorityTip() {
      return this.$t("priority");
    },
    refreshTodayStatisticTip() {
      return this.$t("refreshTodayStatistic");
    },
    todayThreadCountTip() {
      return this.$t("todayThreadCount");
    },
    responseRateToVisitorMessageIn30SecondsTip() {
      return this.$t("responseRateToVisitorMessageIn30Seconds");
    },
    responseRateIn3mComputeMethodTip() {
      return this.$t("responseRateIn3mComputeMethod");
    },
    satisfyRateComputeMethodTip() {
      return this.$t("satisfyRateComputeMethod");
    },
    agentAverageResponseTimeNoteTip() {
      return this.$t("agentAverageResponseTimeNote");
    },
    todaySendMessageCountTip() {
      return this.$t("todaySendMessageCount");
    },
    todaySendMessageWordCountTip() {
      return this.$t("todaySendMessageWordCount");
    },
    todayReceiveMessageCountTip() {
      return this.$t("todayReceiveMessageCount");
    },
    todayReceiveMessageWordCountTip() {
      return this.$t("todayReceiveMessageWordCount");
    },
    inputFeedbackTip() {
      return this.$t("inputFeedback");
    },
    downloadTip() {
      return this.$t("download");
    },
    onlineChatTip() {
      return this.$t("onlineChat");
    },
    helpcenterTip() {
      return this.$t("helpcenter");
    },
    rechargeTip() {
      return this.$t("recharge");
    },
    mpTip() {
      return this.$t("msgNotification");
    },
    showBindCurrentThread() {
      return this.userCurrentThread.tid.trim() > 0 ? true : false;
    },
    showBottomRightButtons() {
      return constants.SHOW_BOTTOM_RIGHT_BUTTONS;
    },
    defaultTitle() {
      return constants.DEFAULT_TITLE;
    },
    valideDate() {
      let valideDate = moment(this.userInfo.validateUntilDate);
      let today = moment(new Date());
      let diff = valideDate.diff(today, "days");
      // if (diff < 7) {
      //   this.valideLt7days('您的账号还剩' + diff + '天，请尽快续期')
      // }
      if (diff < 14) {
        return this.userInfo.validateUntilDate
          ? this.$t("accountValidDate") +
              this.userInfo.validateUntilDate.substring(0, 10) +
              " 还剩" +
              diff +
              "天"
          : "";
      } else {
        return "";
      }
    },
    today() {
      // 增加一个变量方便 刷新date，防止出现第二天显示前一天date的情况
      return this.refreshDate
        ? moment(new Date()).format("MM/DD")
        : moment(new Date()).format("MM/DD");
    },
    bytedeskKfUrl() {
      return (
        "https://vip.kefux.com/chat/pc/iframe.html?sub=vip&uid=201808221551193&wid=201809061716221&type=workGroup&aid=201808221551198&nickname=" +
        this.userInfo.username +
        "&history=1&lang=cn&column=2&ph=ph"
      );
    },
  },
  methods: {
    ...mapActions([
      "init",
      "getProfile",
      // "getProfileCache",
      "transferAccept",
      "transferAccepted",
      "getThreads",
      "getThreadHistoryRecords",
      "getChannelThread",
      "getTicketThread",
      "getTopThreads",
      "getStarThreads",
      "clearToken",
      "persistNoticeBrowse",
      "persistQueue",
      "removeQueue",
      "updateCurrentNoticeBrowse",
      "getTaboos",
      "logout",
      "addNotice",
      "getNotices",
      "getContacts",
      "getAgentTodayStatistics",
      "updateNetworkStatus",
      "updateWebrtcStarted",
      "updateWechatMpBinded",
      "getWechatMpPushStatus",
      "agentCloseThread",
      "removeClosedThread",
      "getWorkGroups"
    ]),
    ...mapActions("mqtt", [
      "sendMessageProtobuf",
      "sendNoticeProtobuf",
      "mqttDisconnect",
    ]),
    //
    isNodisturbThread(thread) {
      return this.userNodisturbThreadTopics.some((topic) => {
        return topic === thread.topic;
      });
    },
    // 显示桌面通知
    showElectronMessageNotification() {
      // Electron 桌面客户端 右上角消息通知
      const notification = {
        title: this.$t("bytedesk"),
        icon: this.iconUrl,
        body: this.$t("newmessage"),
      };
      const myNotification = new window.Notification(
        notification.title,
        notification
      );
      myNotification.onclick = () => {
        // console.log('Notification clicked')
      };
    },
    // 播放提示音
    playAudio() {
      // 读取本地设置，是否播放声音，在setting/BdProfile.vue中设置
      var shouldPlay = Vue.ls.get(constants.PLAY_AUDIO, true);
      if (shouldPlay) {
        var audio = document.getElementById("audioPlay");
        // 浏览器支持 audio
        audio.play();
      }
    },
    onDownload() {
      if (this.electron) {
        ipcRenderer.send("open-external-url", this.downloadUrl);
      } else {
        window.open(this.downloadUrl);
      }
    },
    refreshStatisticData() {
      this.refreshDate = !this.refreshDate;
      // 刷新统计数据
      this.getAgentTodayStatistics();
    },
    onChat() {
      if (this.electron) {
        ipcRenderer.send("open-external-url", this.bytedeskKfUrl);
      } else {
        window.open(this.bytedeskKfUrl);
      }
    },
    onHelp() {
      if (this.electron) {
        ipcRenderer.send("open-external-url", this.helpUrl);
      } else {
        window.open(this.helpUrl);
      }
    },
    onRenew() {
      if (this.electron) {
        ipcRenderer.send("open-external-url", this.renewUrl);
      } else {
        window.open(this.renewUrl);
      }
    },
    // onMp () {
    //   this.centerMpDialogVisible = true
    //   this.queryOpenId()
    // },
    submitRate() {
      console.log("submitRate");
      this.ratePopoverVisible = false;
      // if (this.rateValue.trim().length === 0 || this.rateContent.trim().length === 0) {
      //   return
      // }
      https.rateChatPlatform(
        this.rateValue,
        this.rateContent,
        (response) => {
          console.log("rateChatPlatform:", response);
          //
          this.$message({
            message: this.$t("thankForFeedback"),
            type: "success",
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
    /**
     * 上传图片相关函数
     */
    handleRemove(file, uploadedFileList) {
      console.log(file, uploadedFileList);
      // 删除
      for (var i = 0; i < this.uploadedFileList.length; i++) {
        if (this.uploadedFileList[i].name === file.name) {
          this.uploadedFileList.splice(i, 1);
        }
      }
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, uploadedFileList) {
      this.$message.warning(
        `当前限制选择 6 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + uploadedFileList.length} 个文件`
      );
    },
    beforeRemove(file, uploadedFileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeFileUpload(file) {
      // file.name包含文件后缀
      let timestamp = moment(new Date()).format("YYYYMMDDHHmmss");
      this.upload_data.file_name = timestamp + file.name;
      this.upload_data.username = this.userInfo.username
      this.upload_data.type = constants.UPLOAD_FILE_TYPE_FILE
      // 文件大小控制在2m之内
      this.uploadFileType = file.type;
      const isLt10M = file.size / 1024 / 1024 < 10;
      return isLt10M;
    },
    handleFileUploadSuccess(result, file) {
      console.log("upload file success result:", result, " file:", file);
      if (result.status_code === 200) {
        let url = result.data;
        this.uploadedFileList.push({ name: file.name, url: url });
      } else {
        this.$message.error(this.$t("uploadError"));
      }
    },
    // 显示通知
    // http://javascript.ruanyifeng.com/bom/notification.html
    showNotification(content) {
      // this.notificationGranted(result)
      var notification = new Notification(this.$t("newmessage"), {
        // dir: 'auto',
        // lang: 'zh-CN',
        body: content,
        // tag: 'tag',
        icon: constants.ICON_URL,
      });
      // notification.title // '收到新邮件'
      // notification.body // '您总共有3封未读邮件。'
      //
      notification.onshow = function() {
        // console.log('Notification shown')
        // 自动关闭
        // setTimeout(notification.close.bind(notification), 5000)
      };
      //
      notification.onclick = function() {
        // console.log('notification click')
        // notification.close() //不需要手动关闭，点击之后自会关闭
      };
      //
      notification.onclose = function() {
        // console.log('notification close')
      };
      //
      notification.onerror = function() {
        // console.log('notification error')
      };
    },
    // 请求授权
    requestNotification() {
      // 如果浏览器支持通知，而且用户之前没有授权过通知或者拒绝过通知
      let app = this;
      if (window.Notification && Notification.permission !== "granted") {
        //
        Notification.requestPermission(function(status) {
          if (status === "granted") {
            // var notification = new Notification('通知', {
            //   body: '消息开启成功'
            // })
          } else {
            // alert(app.$t('requestPermission'))
            app.$notify({
              title: "警告",
              message: "/(ㄒoㄒ)/~~，请务必开启消息通知！",
              type: "warning",
            });
          }
        });
      } else {
        // console.log('已经授权或浏览器不支持通知')
      }
    },
    browserTitleNotification() {
      document.title = "(" + this.$t("newmessage") + ")" + this.browserTitle;
    },
    restoreBrowserTitle() {
      document.title = this.browserTitle;
    },
    // 页面标题滚动
    scrollBrowserTitle() {
      // 拿到标题栏的文本
      var title = document.title;
      // 将文本字符串转换为数组
      var arr = title.split("");
      // 拿到数组的第一个元素，并从数组中删除
      var first = arr.shift();
      // 将第一个元素添加到数组的最后
      arr.push(first);
      // 将数组再组合成一个字符串
      title = arr.join("");
      document.title = title;
      // 每隔一秒做一遍前6步
      if (this.shouldScrollBrowserTitle) {
        setTimeout(function() {
          this.scrollBrowserTitle();
        }, 1000);
      }
    },
    sendAcceptMessage(thread) {
      console.log("send accept rtc");
      let payload = {
        type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_ACCEPT,
        content: "接受视频会话",
        thread: thread,
      };
      this.sendMessageProtobuf(payload);
    },
    // 发送拒绝视频邀请信息
    sendRejectMessage(thread) {
      console.log("send reject rtc");
      let payload = {
        type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_REJECT,
        content: "拒绝视频会话",
        thread: thread,
      };
      this.sendMessageProtobuf(payload);
    },
    // 创建工单
    createTicket() {
      //
      if (this.ticket.cid.trim().length === 0) {
        this.$message.error(this.$t("chooseCategory"));
        return;
      }
      if (
        this.ticket.title.trim().length === 0 ||
        this.ticket.content.trim().length === 0
      ) {
        this.$message.error(this.$t("titleOrContentCantBeNull"));
        return;
      }
      if (
        this.ticket.handlerType === "workgroup" &&
        this.ticket.wid.trim().length === 0
      ) {
        this.$message.error(this.$t("pleaseSelectAgent"));
        return;
      }
      if (
        this.ticket.handlerType === "appointed" &&
        this.ticket.uid.trim().length === 0
      ) {
        this.$message.error(this.$t("pleaseSelectAgent"));
        return;
      }
      //
      this.ticket.attachments = [];
      for (let i = 0; i < this.uploadedFileList.length; i++) {
        const element = this.uploadedFileList[i];
        this.ticket.attachments.push(element.url);
      }
      //
      if (this.bindCurrentThread) {
        this.ticket.ttid = this.userCurrentThread.tid;
      }
      // console.log('create ticket:', this.ticket)
      // let contentString = JSON.stringify(this.ticket);
      // console.log('notice:', this.ticket, contentString)
      //
      // if (this.ticket.handlerType === 'workgroup') { // 通知技能组, TODO: 自动为工单分配技能组内某个客服
      //   let payload = { topic: this.ticket.wid, content: contentString, type: constants.NOTICE_TYPE_TICKET }
      //   this.sendNoticeProtobuf(payload)
      // } else { // 通知某个客服
      //   let payload = { topic: this.ticket.uid, content: contentString, type: constants.NOTICE_TYPE_TICKET }
      //   this.sendNoticeProtobuf(payload)
      // }
      this.ticketDrawerVisible = false;
      //
      https.createTicket(
        this.ticket,
        (response) => {
          console.log("create ticket2:", response);
          //
          if (response.status_code === 200) {
            //
            this.$message({
              message: this.$t("createTicketSuccess"),
              type: "success",
            });
          }
          this.ticketDrawerVisible = false;
        },
        (error) => {
          console.log(error);
          this.ticketDrawerVisible = false;
        }
      );
    },
    getTicketCategories() {
      if (this.categoryOptions.length > 1) {
        // 无需重复加载
        return;
      }
      //
      https.getTicketCategories(
        (response) => {
          console.log("ticket categories2:", response);
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            this.categoryOptions.push({
              value: element.cid,
              label: element.name,
            });
          }
          if (this.categoryOptions.length > 0) {
            this.ticket.cid = this.categoryOptions[0].value;
          }
        },
        (error) => {
          console.log("error:", error);
        }
      );
    },
    getAllWorkGroups() {
      if (this.workgroupOptions.length > 0) {
        // 无需重复加载
        return;
      }
      //
      https.getAllWorkGroups(
        (response) => {
          console.log("all workgroups: ", response);
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            this.workgroupOptions.push({
              value: element.wid,
              label: element.nickname,
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    handleSuccess(contacts) {
      for (let i = 0; i < contacts.length; i++) {
        const element = contacts[i];
        this.agentOptions.push({
          value: element.uid,
          label: element.realName,
        });
      }
    },
    handleFailed(error) {
      console.log(error);
    },
    getAllContacts() {
      if (this.agentOptions.length > 0) {
        // 无需重复加载
        return;
      }
      if (this.userContacts.length > 0) {
        for (let i = 0; i < this.userContacts.length; i++) {
          const element = this.userContacts[i];
          this.agentOptions.push({
            value: element.uid,
            label: element.realName,
          });
        }
        return;
      }
      //
      let payload = {
        successcb: this.handleSuccess,
        failedcb: this.handleError,
      };
      this.getContacts(payload);
    },
    showMpDialog(codeUrl) {
      this.centerMpDialogVisible = true;
      setTimeout(() => {
        // 只能放在这里延迟执行，否则会报错：qrcode找不到
        console.log("url:", codeUrl);
        new QRCode($("#mp_qrcode")[0], {
          text: codeUrl,
          width: 128,
          height: 128,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      }, 2000);
    },
    showMpConfirmDialog() {
      this.$confirm("您已绑定公众号, 要重新绑定?", this.$t("tip"), {
        confirmButtonText: this.$t("ok"),
        cancelButtonText: this.$t("cancel"),
        type: "info",
      })
        .then(() => {
          this.queryMpQrcodeUrl();
        })
        .catch(() => {
          this.$message("用户已绑定公众号, 无需重复绑定");
        });
    },
    // 显示二维码
    queryMpQrcodeUrl() {
      // let username = this.userInfo.username
      // console.log('queryMpQrcodeUrl:', username)
      https.queryUserMpQrcodeUrl(
        (response) => {
          // console.log(response)
          // {
          //   ticket: "gQFU8DwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyUXpwQ1FkQmk5WGUxUUZaT3h2Y0kAAgQp8MpfAwQAjScA",
          //   expire_seconds: 2592000,
          //   url: "http://weixin.qq.com/q/02QzpCQdBi9Xe1QFZOxvcI"
          // }
          if (response.url != null && response.url.length > 0) {
            this.showMpDialog(response.url);
          } else {
            // this.$message('qrcode url query failed')
            // this.showMpDialog('http://weixin.qq.com/q/02QzpCQdBi9Xe1QFZOxvcI') // test
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    autoQueryOpenId() {
      if (!this.isProduction) {
        return
      }
      this.shouldQueryMpQrcodeUrl = Vue.ls.get(constants.QUERY_MPQRCODE_URL, true);
      if (this.shouldQueryMpQrcodeUrl) {
        https.queryUserMpOpenId(
          (response) => {
            console.log('queryUserMpOpenId:', response)
            if (response.status_code === -1) {
              // console.log("用户未绑定公众号");
              this.queryMpQrcodeUrl();
            } else if (response.status_code === 200) {
              // this.$message('用户已绑定公众号, 无需重复绑定')
              this.updateWechatMpBinded(true)
              this.getWechatMpPushStatus()
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
    queryOpenId() {
      // let username = this.userInfo.username
      // console.log('queryMpQrcodeUrl:', username)
      if (!this.isProduction) {
        return
      }
      https.queryUserMpOpenId(
        (response) => {
          console.log(response);
          if (response.status_code === -1) {
            // console.log("用户未绑定公众号");
            this.queryMpQrcodeUrl();
          } else if (response.status_code === 200) {
            // this.$message('用户已绑定公众号, 无需重复绑定')
            this.showMpConfirmDialog();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    handleDrawerClose(done) {
      done();
    },
    // 检测是否到期
    validate() {
      let valideDate = moment(this.userInfo.validateUntilDate);
      let today = moment(new Date());
      let diff = valideDate.diff(today, "days");
      if (diff < 7) {
        this.valideLt7days("您的账号还剩" + diff + "天，请尽快续期");
      }
    },
    valideLt7days(tip) {
      // this.$alert(tip, this.$t('tip'), {
      //   confirmButtonText: this.$t('ok'),
      //   callback: action => {
      //     //
      //   }
      // });
      this.$confirm(tip, this.$t("tip"), {
        confirmButtonText: this.$t("ok"),
        cancelButtonText: "为什么已经充值，还提示续期？",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {
          // 在浏览器打开管理后台充值地址
          if (this.electron) {
            ipcRenderer.send("open-external-url", this.rechargeHelpUrl);
          } else {
            window.open(this.rechargeHelpUrl);
          }
        });
    },
    urlB64ToUint8Array(base64String) {
      const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
      const base64 = (base64String + padding)
        .replace(/\-/g, "+")
        .replace(/_/g, "/");

      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },
    // 视频会话忙信息
    sendBusyMessage(thread) {
      console.log("send busy rtc");
      let payload = {
        type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_BUSY,
        content: "对方忙",
        thread: thread,
      };
      this.sendMessageProtobuf(payload);
    },
    // https://github.com/web-push-libs/webpush-java/wiki/Usage-Example
    initialiseWebPushServiceWorkerState() {
      // console.log("initialiseWebPushServiceWorkerState");
      let app = this;
      // Check if desktop notifications are supported
      if (!("showNotification" in ServiceWorkerRegistration.prototype)) {
        // safari不支持
        console.warn("Notifications aren't supported.");
        return;
      }
      // Check if user has disabled notifications
      // If a user has manually disabled notifications in his/her browser for
      // your page previously, they will need to MANUALLY go in and turn the
      // permission back on. In this statement you could show some UI element
      // telling the user how to do so.
      if (Notification.permission === "denied") {
        console.warn("The user has blocked notifications.");
        return;
      }
      // Check is push API is supported
      if (!("PushManager" in window)) {
        console.warn("Push messaging isn't supported.");
        return;
      }
      //
      navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
        // Get the push notification subscription object
        serviceWorkerRegistration.pushManager
          .getSubscription()
          .then(function(subscription) {
            // If this is the user's first visit we need to set up
            // a subscription to push notifications
            if (!subscription) {
              app.subscribe();
              return;
            }
            // Update the server state with the new subscription
            app.sendSubscriptionToServer(subscription);
          })
          .catch(function(err) {
            // Handle the error - show a notification in the GUI
            console.warn("Error during getSubscription()", err);
          });
      });
    },
    /**
     * Step three: Create a subscription. Contact the third party push server (for
     * example mozilla's push server) and generate a unique subscription for the
     * current browser.
     */
    subscribe() {
      let app = this;
      const applicationServerKey = this.urlB64ToUint8Array(
        this.applicationServerPublicKey
      );
      navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
        // Contact the third party push server. Which one is contacted by
        // pushManager is  configured internally in the browser, so we don't
        // need to worry about browser differences here.
        //
        // When .subscribe() is invoked, a notification will be shown in the
        // user's browser, asking the user to accept push notifications from
        // <yoursite.com>. This is why it is async and requires a catch.
        serviceWorkerRegistration.pushManager
          .subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerKey,
          })
          .then(function(subscription) {
            // Update the server state with the new subscription
            return app.sendSubscriptionToServer(subscription);
          })
          .catch(function(e) {
            if (Notification.permission === "denied") {
              console.warn("Permission for Notifications was denied");
            } else {
              console.error("Unable to subscribe to push.", e);
            }
          });
      });
    },
    /**
     * Step four: Send the generated subscription object to our server.
     */
    sendSubscriptionToServer(subscription) {
      // TODO: Send subscription to application server
      // subscription: {
      // "endpoint":"https://fcm.googleapis.com/fcm/send/fIHKQY3VWus:APA91bFRDFOHdCxFLJLtj9DLelYC8PTxbDBvITJKIi9dKHAoullUsxPNZbhaolLASTJW1vb7Uy5x8e0n9_UUgjS8G5sb04SOVn_1ad-cg_QnpWu2Equ66M2FWL2OKEMNzimSaIt2ay1b",
      // "expirationTime":null,
      // "keys":{"p256dh":"BPhK_ybH2P3yfLLq3so62SmHf-yg9b5-zesS3pPZ4c2wCeYKnukd4yfcoixHqdUg3R_y9jXzafNtsbggM-BDlgE","auth":"jIBBeuGNdtwtNhrhwt4fzg"}
      // }
      // console.log('subscription:' + JSON.stringify(subscription))
      let endpoint = subscription.endpoint;
      let keysObject = JSON.parse(JSON.stringify(subscription)).keys;
      let key = keysObject.p256dh;
      let auth = keysObject.auth;
      // console.log('endpoint:' + endpoint)
      // console.log('key:' + key)
      // console.log('auth:' + auth)
      https.updateToken(
        endpoint,
        key,
        auth,
        (response) => {
          // console.log('updateToken:')
          // console.log(response)
        },
        (error) => {
          console.log(error);
        }
      );
      // This example uses the new fetch API. This is not supported in all
      // browsers yet.
      // return fetch('/profile/subscription', {
      //     method: 'POST',
      //     headers: {
      //         'Content-Type': 'application/json'
      //     },
      //     body: JSON.stringify({
      //         endpoint: subscription.endpoint,
      //         // Take byte[] and turn it into a base64 encoded string suitable for
      //         // POSTing to a server over HTTP
      //         key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : '',
      //         auth: auth ? btoa(String.fromCharCode.apply(null, new Uint8Array(auth))) : ''
      //     })
      // });
    },
  },
  created() {
    // 验证私有部署服务有效性
    if (constants.IS_PRIVATE_SERVER) {
      // 针对学有优教app限定日期
      let valideDate = moment(constants.PRIVATE_SERVER_VALIDEDATE);
      let today = moment(new Date());
      let diff = valideDate.diff(today, "days");
      if (diff < 2) {
        // 无效用户
        let app = this;
        this.$alert(app.$t("outOfDate"), app.$t("tip"), {
          confirmButtonText: app.$t("ok"),
          callback: (action) => {
            app.logout();
          },
        });
      }
      // https.serverValidate(constants.PRIVATE_SERVER_UID, response => {
      //   console.log(response)
      //   if (!response.data.valid) {
      //     // 无效用户
      //     this.$alert(response.data.message, this.$t('tip'), {
      //       confirmButtonText: this.$t('ok'),
      //       callback: action => {
      //         this.logout()
      //       }
      //     })
      //   }
      // }, error => {
      //   console.log(error)
      // })
    }
    // TODO: 验证当前登录坐席数量，是否超过购买数量
    // 从localstorage中加载access_token
    this.init();
    // 客服个人资料，为加快加载速度，特增加上面一个cache版本
    // this.getProfileCache();
    this.getProfile();
    // 当前进行中会话
    this.getThreads();
    // 拉取置顶会话
    this.getTopThreads()
    // 拉取星标会话
    this.getStarThreads()
    // 频道会话
    // this.getChannelThread();
    // 加载历史记录
    let payload = { page: 0, size: 20 };
    this.getThreadHistoryRecords(payload);
    // 工单会话
    // this.getTicketThread();
    // 请求浏览器通知权限
    this.requestNotification();
    // 当前客服实时统计数据
    this.getAgentTodayStatistics();
    // 提示用户绑定公众号，接收消息通知
    this.autoQueryOpenId();
    // 拉取敏感词
    this.getTaboos(payload);
    // 拉取所有技能组
    this.getWorkGroups()
  },
  mounted() {
    this.browserTitle = document.title;
    // this.showBottomRightButtons = Vue.ls.get(constants.SHOW_BOTTOM_STATISTIC, true)
    // 监听浏览器显示或隐藏当前页面
    document.addEventListener(
      "visibilitychange",
      () => {
        // console.log('visibilitychange:', document.visibilityState)
        if (document.visibilityState === "hidden") {
          // console.log('隐藏')
          this.hidden = true;
          // TODO: 在隐藏当前tab之后，收到新消息时需要页面tab标题滚动
        } else if (document.visibilityState === "visible") {
          // console.log('显示')
          this.hidden = false;
          // this.shouldScrollBrowserTitle = false
          this.restoreBrowserTitle();
        }
      },
      false
    );
    let app = this;
    window.addEventListener("online", function () {
      let showNetworkStatus = Vue.ls.get(constants.SHOW_NETWORK_STATUS, true)
      if (showNetworkStatus) {
        app.showNotification("网络恢复");
      }
      // console.log('监听：网络连接上了')
      let payload = { status: constants.NETWORK_CONNECTION_STATUS_CONNECTED };
      app.updateNetworkStatus(payload);
    });
    window.addEventListener("offline", function () {
      let showNetworkStatus = Vue.ls.get(constants.SHOW_NETWORK_STATUS, true)
      if (showNetworkStatus) {
        app.showNotification("网络已断开");
        app.$notify({
          title: app.$t("tip"),
          message: "网络已断开",
        });
      }
      // console.log('监听：网络断开了')
      let payload = {
        status: constants.NETWORK_CONNECTION_STATUS_DISCONNECTED,
      };
      app.updateNetworkStatus(payload);
    });
    // 收到新消息
    bus.$on(constants.EVENT_BUS_NEW_MESSAGE, (message) => {
      // console.log('new message notify:', message)
      // 过滤掉离线、上线消息、会话自动关闭消息
      if (
        message.type === constants.MESSAGE_TYPE_NOTIFICATION_CONNECT ||
        message.type === constants.MESSAGE_TYPE_NOTIFICATION_DISCONNECT ||
        message.type === constants.MESSAGE_TYPE_NOTIFICATION_AUTO_CLOSE
      ) {
        return;
      }
      if (this.isNodisturbThread(message.thread)) {
        return;
      }
      // 收到新消息通知, 判断是否弹出提示框，只有主窗口被关闭的情况才会
      if (this.electron) {
        // Mac右上角通知提示框, windows不显示
        let focused = ipcRenderer.sendSync("is-focused", "ping");
        if (!focused) {
          this.showElectronMessageNotification();
        }
        // Windows桌面右下角弹窗提醒：定义一个Window
        if (message.type === constants.MESSAGE_TYPE_NOTIFICATION_THREAD) {
          // 区分新访客进入
          ipcRenderer.send("new-visitor", message);
        } else {
          // 收到新消息
          ipcRenderer.send("new-message", message);
        }
      } else if (this.hidden) {
        // 浏览器客服窗口非当前页，弹出通知
        let notice = message.user.nickname + ":" + message.content;
        if (message.type === constants.MESSAGE_TYPE_IMAGE) {
          // message.content = this.$t('image');
          notice = message.user.nickname + ":" + this.$t("image");
        } else if (message.type === constants.MESSAGE_TYPE_FILE) {
          // message.content = this.$t('file')
          notice = message.user.nickname + ":" + this.$t("file");
        } else if (message.type === constants.MESSAGE_TYPE_VOICE) {
          // message.content = this.$t('voice')
          notice = message.user.nickname + ":" + this.$t("voice");
        } else if (message.type === constants.MESSAGE_TYPE_VIDEO) {
          // message.content = this.$t('video')
          notice = message.user.nickname + ":" + this.$t("video");
        } else if (message.type === constants.MESSAGE_TYPE_COMMODITY) {
          // message.content = '商品' //this.$t('commodity')
          notice = message.user.nickname + ":" + this.$t("commodity");
        }
        // 判断是否设置了显示新消息通知窗口
        var shouldShowNotificationWindow = Vue.ls.get(
          constants.SHOW_NOTIFICATION_WINDOW,
          true
        );
        if (shouldShowNotificationWindow) {
          this.showNotification(notice);
        }
        this.browserTitleNotification();
        // this.scrollBrowserTitle()
      }
      // 播放声音
      this.playAudio();
    });
    // 非会话消息，如：会议通知等
    bus.$on(constants.EVENT_BUS_MESSAGE_NOTICE, (message) => {
      //
      if (message.notice.type === constants.MESSAGE_TYPE_NOTIFICATION_BROWSE) {
        let contentObject = JSON.parse(message.notice.content);
        message.notice.content = {
          referer: decodeURI(contentObject.referer),
          url: decodeURI(contentObject.url),
          title: decodeURI(contentObject.title),
        };
        this.persistNoticeBrowse(message);
      } else if (message.notice.type === constants.MESSAGE_TYPE_NOTIFICATION_QUEUE) {
        let contentObject = JSON.parse(message.notice.content);
        // console.log(
        //   "MESSAGE_TYPE_NOTIFICATION_QUEUE ",
        //   message,
        //   contentObject.qid
        // );
        // 1.持久化
        let queue = contentObject;
        this.persistQueue(queue);
        // 收到新消息通知, 判断是否弹出提示框，只有主窗口被关闭的情况才会
        if (this.electron) {
          // Mac右上角通知提示框, windows不显示
          let focused = ipcRenderer.sendSync("is-focused", "ping");
          if (!focused) {
            this.showElectronMessageNotification();
          }
        } else if (this.hidden) {
          // 浏览器客服窗口非当前页，弹出通知
          this.showNotification(this.$t("queues"));
        }
        // 播放声音
        this.playAudio();
      } else if (message.notice.type === constants.MESSAGE_TYPE_NOTIFICATION_QUEUE_ACCEPT) {
        console.log('message.notice.content:', message.notice.content);
        // let contentObject = JSON.parse(message.content);
        // console.log('MESSAGE_TYPE_NOTIFICATION_QUEUE_ACCEPT ', message, contentObject.qid)
        // 排队访客被接入
        // let qid = contentObject.qid;
        let qid = message.notice.content;
        this.removeQueue(qid);
      } else if (
        message.notice.type === constants.MESSAGE_TYPE_NOTIFICATION_QUEUE_LEAVE
      ) {
        let contentObject = JSON.parse(message.notice.content);
        // console.log('MESSAGE_TYPE_NOTIFICATION_QUEUE_LEAVE ', message, contentObject.qid)
        // 排队访客离开
        let qid = contentObject.qid;
        this.removeQueue(qid);
      } else if (
        message.notice.type === constants.MESSAGE_TYPE_NOTIFICATION_QUEUE_IGNORE
      ) {
        // let contentObject = JSON.parse(message.notice.content);
        // console.log('MESSAGE_TYPE_NOTIFICATION_QUEUE_IGNORE ', message, contentObject.qid)
        // 排队访客被忽略
        // let qid = contentObject.qid;
        let qid = message.notice.content
        this.removeQueue(qid);
      } else if (
        message.notice.type ===
        constants.MESSAGE_TYPE_NOTIFICATION_QUEUE_TIMEOUT
      ) {
        let contentObject = JSON.parse(message.notice.content);
        // console.log('MESSAGE_TYPE_NOTIFICATION_QUEUE_TIMEOUT ', message, contentObject.qid)
        // 排队访客超时
        let qid = contentObject.qid;
        this.removeQueue(qid);
      } else if (
        message.notice.type === constants.MESSAGE_TYPE_NOTIFICATION_KICKOFF
      ) {
        // 踢掉线通知
        // {"uuid":"a60f24aa-cb2d-ca2e-686e-df92ae050268","client":"web"}
        let contentObject = JSON.parse(message.notice.content);
        // console.log('MESSAGE_TYPE_NOTIFICATION_KICKOFF ', message)
        // 首先判断是不是自己发的通知
        let client = contentObject.client;
        let ipinfo = contentObject.ipinfo;
        let uuid = Vue.ls.get(constants.KICKOFF_UUID);
        if (contentObject.uuid !== uuid) {
          // 如果不是自己发的通知，则弹窗提示
          // 添加时间戳/来源客户端等信息，message.timestamp/contentObject.client
          const h = this.$createElement;
          this.$msgbox({
            title: this.$t("tip"),
            message: h("p", null, [
              h("p", null, this.$t("loginOtherClient")),
              h(
                "p",
                { style: "color: teal" },
                this.$t("client") + ": " + client
              ),
              h(
                "p",
                { style: "color: teal" },
                this.$t("ipinfo") + ": " + ipinfo
              ),
              h(
                "p",
                { style: "color: teal" },
                this.$t("timestamp") + ": " + message.timestamp
              ),
            ]),
            showCancelButton: true,
            confirmButtonText: this.$t("iknow"),
            cancelButtonText: this.$t("cancel"),
            // beforeClose: (action, instance, done) => {
            //   if (action === 'confirm') {
            //     instance.confirmButtonLoading = true;
            //     instance.confirmButtonText = '执行中...';
            //     setTimeout(() => {
            //       done();
            //       setTimeout(() => {
            //         instance.confirmButtonLoading = false;
            //       }, 300);
            //     }, 3000);
            //   } else {
            //     done();
            //   }
            // }
          }).then((action) => {
            // console.log('action:', action)
            // 非自己，但是同类型客户端，则退出登录
            if (client === constants.HTTP_CLIENT) {
              // 执行退出登录
              this.logout();
            }
            // this.$message({
            //   type: 'info',
            //   message: 'action: ' + action
            // });
          });
          // TODO: 5秒钟之后自动退出登录
          setTimeout(() => {
            // 执行退出登录
            this.logout();
          }, 5000);
          // this.$confirm(this.$t('loginOtherClient'), this.$t('tip'), {
          //   confirmButtonText: this.$t('iknow'),
          //   // cancelButtonText: this.$t('cancel'),
          //   type: 'info',
          //   center: true
          // }).then(() => {
          //   // 忽略
          // }).catch(() => {
          //   // TODO: 将对方踢掉线
          //   // TODO: 自己退出登录
          // })
        }
        //
      } else if (message.notice.type === constants.NOTICE_TYPE_NORMAL) {
        let contentObject = JSON.parse(message.notice.content);
        // console.log('NOTICE_TYPE_NORMAL ', message)
        // 普通通知
        this.$notify.info({
          // title: this.$t('tip'),
          // message: this.$t('receiveNotice'),
          title: contentObject.title,
          message: contentObject.content,
          duration: 0,
          onClick: () => {
            console.log("click notice");
            // //
            // let payload = { page: 0, size: 100 }
            // this.getNotices(payload)
            //
            this.$router.replace("/admin/notice");
          },
        });
      } else if (message.notice.type === constants.NOTICE_TYPE_TICKET) {
        // 工单相关通知：创建、进度更新等
        this.$notify.info({
          title: this.$t("tip"),
          message: this.$t("ticketNotice"),
          duration: 0,
          onClick: () => {
            // console.log('click ticket')
            this.$router.replace("/admin/ticket");
          },
        });
      } else if (message.notice.type === constants.NOTICE_TYPE_TODO) {
        console.log("待办任务 NOTICE_TYPE_TODO");
        let contentObject = JSON.parse(message.notice.content);
        // 待办任务
        this.$notify.info({
          title: contentObject.title,
          message: contentObject.content,
          duration: 0,
          onClick: () => {
            console.log("click todo");
            //
            this.$router.replace("/admin/todo");
          },
        });
      }
    });
    // 工单通知
    bus.$on(constants.EVENT_BUS_SUPPORT_NEW_TICKET, (message) => {
      // 工单相关通知：创建、进度更新等
      this.$notify.info({
        title: this.$t("tip"),
        message: this.$t("ticketNotice"),
        onClick: () => {
          this.$router.replace("/admin/ticket");
        },
      });
    });
    // 邀请视频
    bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_INVITE_VIDEO, (message) => {
      console.log("dashboard invite video");
      //
      if (this.isWebrtcStarted) {
        this.sendBusyMessage(message.thread);
        return;
      }
      //
      this.$confirm(message.thread.nickname + "邀请视频?", this.$t("tip"), {
        confirmButtonText: this.$t("acceptInvite"),
        cancelButtonText: this.$t("rejectInvite"),
        type: "info",
        center: true,
        showClose: false, // MessageBox 是否显示右上角关闭按钮
        closeOnClickModal: false, // 是否可通过点击遮罩关闭 MessageBox
        closeOnPressEscape: false, // 是否可通过按下 ESC 键关闭 MessageBox
      })
        .then(() => {
          // 防止同时存在多个弹窗邀请的情况：前面一个邀请未处理，又进来一个新邀请。点击接受第一个邀请之后，再点击后面的邀请时，直接发送忙消息
          if (this.isWebrtcStarted) {
            this.sendBusyMessage(message.thread);
            return;
          }
          // 接受邀请
          this.sendAcceptMessage(message.thread);
          // 更新视频客服状态为占用
          this.updateWebrtcStarted(true);
          // 通知显示右侧音视频tab
          bus.$emit(constants.EVENT_BUS_WEBRTC_ACCEPT, message);
        })
        .catch(() => {
          // 拒绝
          this.sendRejectMessage(message.thread);
          let tid = message.thread.tid;
          // 从会话列表移除
          this.removeClosedThread(tid);
          // 向服务器发送关闭会话通知
          this.agentCloseThread(tid);
        });
    });
    // 邀请音频
    bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_INVITE_AUDIO, (message) => {
      console.log("dashboard invite audio");
      //
      if (this.isWebrtcStarted) {
        this.sendBusyMessage(message.thread);
        return;
      }
      //
      this.$confirm(message.thread.nickname + "邀请音频?", this.$t("tip"), {
        confirmButtonText: this.$t("acceptInvite"),
        cancelButtonText: this.$t("rejectInvite"),
        type: "info",
        center: true,
        showClose: false, // MessageBox 是否显示右上角关闭按钮
        closeOnClickModal: false, // 是否可通过点击遮罩关闭 MessageBox
        closeOnPressEscape: false, // 是否可通过按下 ESC 键关闭 MessageBox
      })
        .then(() => {
          // 防止同时存在多个弹窗邀请的情况：前面一个邀请未处理，又进来一个新邀请。点击接受第一个邀请之后，再点击后面的邀请时，直接发送忙消息
          if (this.isWebrtcStarted) {
            this.sendBusyMessage(message.thread);
            return;
          }
          // 接受邀请
          this.sendAcceptMessage(message.thread);
          // 更新视频客服状态为占用
          this.updateWebrtcStarted(true);
          // 通知显示右侧音视频tab
          bus.$emit(constants.EVENT_BUS_WEBRTC_ACCEPT, message);
        })
        .catch(() => {
          // 拒绝
          this.sendRejectMessage(message.thread);
          let tid = message.thread.tid;
          // 从会话列表移除
          this.removeClosedThread(tid);
          // 向服务器发送关闭会话通知
          this.agentCloseThread(tid);
        });
    });
    // 转接会话请求
    bus.$on(constants.EVENT_BUS_NOTIFICATION_TRANSFER, (message) => {
      this.$msgbox({
        title: this.$t("transfer"),
        message: message.user.nickname + this.$t("transferThread"),
        showCancelButton: true,
        confirmButtonText: this.$t("accept"),
        cancelButtonText: this.$t("reject"),
        beforeClose: (action, instance, done) => {
          console.log("beforeClose:", action);
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = this.$t("processing");
            // 接受转接
            let payload = {
              type: constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER_ACCEPT,
              content: { topic: message.user.uid },
              thread: message.thread,
            };
            this.sendMessageProtobuf(payload);
            // 本地持久化处理thread
            this.transferAccept(message);
            done();
            instance.confirmButtonLoading = false;
          } else {
            // 拒绝转接
            let payload = {
              type: constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER_REJECT,
              content: { topic: message.user.uid },
              thread: message.thread,
            };
            this.sendMessageProtobuf(payload);
            done();
          }
        },
      }).then((action) => {
        console.log("then:", action);
      });
    });
    // 转接会话请求发送成功
    bus.$on(constants.EVENT_BUS_NOTIFICATION_TRANSFER_SENDOK, (message) => {
      let content = this.$t("transferSendOk");
      this.$notify({
        title: this.$t("tip"),
        message: content,
        type: "success",
      });
    });
    // 监听到转移会话被同意
    bus.$on(constants.EVENT_BUS_NOTIFICATION_TRANSFER_ACCEPT, (message) => {
      let content = message.user.nickname + this.$t("acceptTransfer");
      this.$notify({
        title: this.$t("tip"),
        message: content,
        type: "success",
      });
      // 转移会话被接受，删除本地相应thread
      this.transferAccepted(message);
    });
    // 监听到转移会话被拒绝
    bus.$on(constants.EVENT_BUS_NOTIFICATION_TRANSFER_REJECT, (message) => {
      let content = message.user.nickname + this.$t("rejectTransfer");
      this.$notify({
        title: this.$t("tip"),
        message: content,
        type: "warning",
      });
    });
    // 邀请会话请求
    bus.$on(constants.EVENT_BUS_NOTIFICATION_INVITE, (message) => {});
    bus.$on(constants.EVENT_BUS_NOTIFICATION_INVITE_ACCEPT, (message) => {
      let content = message.user.nickname + this.$t("acceptInvite");
      this.$notify({
        title: this.$t("tip"),
        message: content,
        type: "success",
      });
    });
    bus.$on(constants.EVENT_BUS_NOTIFICATION_INVITE_REJECT, (message) => {
      let content = message.user.nickname + this.$t("rejectInvite");
      this.$notify({
        title: this.$t("tip"),
        message: content,
        type: "warning",
      });
    });
    // 退出登录，跳转到登录页面
    bus.$on(constants.EVENT_BUS_LOGOUT, (message) => {
      // 401、403的情况下，需要清空下storage
      this.mqttDisconnect();
      this.clearToken();
      this.$router.replace("/login");
      window.location.reload();
      // Electron 隐藏tray图标
      if (this.electron) {
        // ipcRenderer.send('hide-tray', '')
        // FIXME: 在windows客户端存在bug：当点击左下角退出登录的时候，重新登录账户会一直处于连接中状态，故暂时采取关闭客户端的方式。重新打开客户端登录可以正常登录
        ipcRenderer.send("quit", "");
      }
    });
    // 显示创建工单drawer
    bus.$on(constants.EVENT_BUS_SHOW_TICKET_DRAWER, (message) => {
      //
      this.ticketDrawerVisible = true;
      //
      this.getTicketCategories();
      this.getAllWorkGroups();
      this.getAllContacts();
    });
    // 账号到期
    bus.$on(constants.EVENT_BUS_OUT_OF_SERVICE, (message) => {
      this.$alert(this.$t("outOfDate"), this.$t("tip"), {
        confirmButtonText: this.$t("ok"),
        callback: (action) => {
          // 在浏览器打开管理后台充值地址
          if (this.electron) {
            ipcRenderer.send("open-external-url", this.rechargeUrl);
          } else {
            window.open(this.rechargeUrl);
          }
          // 退出登录
          this.logout();
        },
      });
    });
    bus.$on(constants.EVENT_BUS_VALIDATE_DATE, (message) => {
      this.validate();
    });
    bus.$on(constants.EVENT_BUS_NOTIFICATION_SUCCESS, (message) => {
      this.$notify({
        title: this.$t("tip"),
        message: message,
        type: "success",
      });
    });
    bus.$on(constants.EVENT_BUS_NOTIFICATION_WARNING, (message) => {
      this.$notify({
        title: this.$t("tip"),
        message: message,
        type: "warning",
      });
    });
    bus.$on(constants.EVENT_BUS_NOTIFICATION_INFO, (message) => {
      this.$notify({ title: this.$t("tip"), message: message, type: "info" });
    });
    bus.$on(constants.EVENT_BUS_NOTIFICATION_ERROR, (message) => {
      // TODO: 某些地方数据加载慢，报错，暂时隐藏
      if (!constants.IS_PRODUCTION) {
        this.$notify({
          title: this.$t("tip"),
          message: message,
          type: "error",
        });
      }
    });
    // web push 仅用于web
    if (!this.electron && !constants.IS_PRIVATE_SERVER) {
      // https://github.com/web-push-libs/webpush-java/wiki/Usage-Example
      // registerServiceWorker({ scope: '/' }).then(this.initialiseWebPushServiceWorkerState);
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("/sw.js")
          .then(this.initialiseWebPushServiceWorkerState);
      } else {
        console.warn("Service workers are not supported in this browser.");
      }
    }
    // TODO: 长连接已经断开，考虑是否显示此提示？容易让用户有系统不稳定的怀疑？
    // bus.$on(constants.EVENT_BUS_DISCONNECTED, (message) => {
    //   // this.$notify({ title: this.$t('tip'), message: this.$t('disconnected'), type: 'error' })
    // });
    // if (this.timer) {
    //   clearInterval(this.timer);
    // } else {
    //   this.timer = setInterval(() => {
    //     // TODO: 当前客服实时统计数据, 减小服务器压力，暂时注释掉
    //     // this.getAgentTodayStatistics()
    //   }, 1000 * 60 * 5); // 5分钟刷新一次
    // }
    // let local = Vue.ls.get(constants.I18N) == null ? 'zh' : Vue.ls.get(constants.I18N)
    // this.$i18n.locale = local
    // this.$i18n.locale = 'en'
    // 百度翻译
    // let appid = '20220719001276956'
    // let q = 'apple'
    // let salt = moment(new Date()).format('YYYYMMDDHHmmss')
    // let key = 'bcwbFPKJcDVyFixkHtis'
    // let string1 = appid + q + salt + key
    // let sign = md5(string1)
    // // ed1e0ee6711e39d4f22b322fd7f62c53 20220719001276956apple20221102073705bcwbFPKJcDVyFixkHtis
    // console.log(sign, string1)
  },
  destroyed() {
    // clearInterval(this.timer);
  },
  filters: {
    datetime(value) {
      if (typeof value === "string") {
        return moment(value).format("YYYY-MM-DD");
      } else {
        return value;
      }
    },
  },
};
</script>

<style scoped>
/* @import url("https://at.alicdn.com/t/font_761687_pewb9n5owr.css"); */
/* @import url("//at.alicdn.com/t/c/font_761687_3ukbep32yi7.css"); */
/* @import url("//at.alicdn.com/t/c/font_761687_7r9jbpkvulp.css"); */
@import url("https://cdn.kefux.com/assets/css/vendor/iconfontchaty/iconfont.css");

#bd-dashboard {
  width: 100%;
  height: 100%;
}
.statistic-data {
  float: left;
  font-size: 10px;
  font-style: normal;
  cursor: pointer;
  margin-right: 10px;
}
.help-chat {
  cursor: pointer;
  float: right;
  margin-top: 2px;
  margin-right: 10px;
}
.el-container {
  height: 100%;
}
.el-aside {
  background-color: #d3dce6;
  color: #333;
}
.el-main {
  background-color: #f2f2f2;
  color: #333;
  padding: 0px !important;
  height: 100%;
}
.el-footer {
  background-color: #d3dce6;
  overflow: hidden;
}
.bd-upload-file {
  font-size: 25px;
  color: gray;
  margin-left: 20px;
  cursor: pointer;
  float: left;
  list-style: none;
}
.demo-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px;
  overflow-y: scroll;
  text-align: left;
}
.demo-drawer__footer {
  position: absolute;
  bottom: 5px;
}
.el-form {
  margin-bottom: 0px;
}
</style>
